import script from "./ViewBanksPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBanksPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewBanksPage.vue?vue&type=style&index=0&id=ee34961e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee34961e"]])

export default __exports__